import React, { useRef, useEffect, useState } from 'react';
import './Boots.scss';
import { gsap } from '../../../../gsap';
import { useCountUp } from 'react-countup';
import videomov from '../../../../assets/artemis/boots/artemis_boots_desktop.mov';
import video from '../../../../assets/artemis/boots/artemis_boots_desktop.webm';
import poster from '../../../../assets/artemis/boots/artemis_boots_desktop_poster.png';
import videomovD from '../../../../assets/artemis/boots/artemis_boots_desktop.mov';
import videoD from '../../../../assets/artemis/boots/artemis_boots_desktop.webm';
import posterD from '../../../../assets/artemis/boots/artemis_boots_desktop_poster.png';

function ArtemisBoots({ screenWidth }) {
  const videoMRef = useRef();
  const videoDRef = useRef();
  const bootsRef = useRef();
  const highlight1 = useRef();
  const highlight2 = useRef();

  const [showCounter, setShowCounter] = useState(false);
  const SimpleHook = () => {
    useCountUp({
      ref: 'counter',
      end: 10,
      start: 0,
      duration: 2
    });
    return <span id="counter" />;
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          if (entry['isIntersecting'] === true) {
            if (entry['intersectionRatio'] > 0.6) {
              screenWidth > 480 ? videoDRef.current.play() : videoMRef.current.play();
              setShowCounter(true);
            }
          }
        });
      },
      { threshold: [0, 0.6] }
    );
    observer.observe(bootsRef.current);
  }, [screenWidth]);

  useEffect(() => {
    const refs = [highlight1, highlight2];

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: highlight1.current,
        start: 'top 60%'
      }
    });
    refs.forEach((ref, i) => {
      i === 0
        ? tl
            .to(
              ref.current,
              {
                color: '#FFFFFF',
                duration: 0.7
              },
              '<'
            )
            .to(ref.current, {
              color: '#767676',
              duration: 0.7
            })
        : tl.to(ref.current, {
            color: '#FFFFFF',
            duration: 0.7
          });
    });
  }, []);

  return (
    <section className="boots boots-artemis">
      <div className="boots__text boots__text-artemis">
        <p className="boots__text__copy boots__text__copy-artemis" ref={highlight1}>
          The first Artemis missions will focus on the lunar South Pole. The xEMU prototype includes
          “hiking-style” boots for trekking there.
        </p>
        <p className="boots__text__copy boots__text__copy-artemis" ref={highlight2}>
          Eventually, crewed rovers will help the astronauts explore distances farther than they
          could walk.
        </p>
      </div>
      <div className="boots__animation boots__animation-artemis" ref={bootsRef}>
        {screenWidth > 480 ? (
          <video
            muted
            playsInline
            preload="auto"
            ref={videoDRef}
            className="video"
            poster={posterD}
          >
            <source src={videomovD} type="video/quicktime" />
            <source src={videoD} type="video/webm" />
          </video>
        ) : (
          <video muted playsInline preload="auto" ref={videoMRef} className="video" poster={poster}>
            <source src={videomov} type="video/quicktime" />
            <source src={video} type="video/webm" />
          </video>
        )}
        <div className="boots__animation__countdown">
          <h6 className="boots__animation__countdown__number">
            {showCounter ? <SimpleHook /> : `0`}
          </h6>
          <p className="boots__animation__countdown__copy">
            number of miles astronauts on the first artemis missions may be asked to cover on
            moonwalks
          </p>
        </div>
      </div>
    </section>
  );
}

export default ArtemisBoots;
